import { RulesTypes } from '../../screens/component-props.model';

export const handleNextRouteLastPathConversion = (parentRoute: string, nextRoute?: RulesTypes<string> | string) => {
  if (nextRoute !== undefined) return parentRoute.replace(/\/[^\/]*$/, `${nextRoute}`);

  return parentRoute.replace(/\/[^\/]*$/, '');
};
